// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2uWt3","footer":"ChangeClinic_footer__2601y"};